import { useTranslation } from 'react-i18next'

import { CashbackIcon, Tooltip } from '@blade/ui-kit'

import { PairElementContainer } from './pair-element-container'

import type { ClassNameProps } from '@root/shared/react'

type PairCashbackBadgeProps = {
  size?: number
  onClick?: (
    e:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => void
} & ClassNameProps

export const PairCashbackBadge: React.FC<PairCashbackBadgeProps> = ({
  size = 14,
  onClick,
}) => {
  const { t } = useTranslation()

  return (
    <Tooltip content={t('pair.cashback-mode.tooltip')}>
      <PairElementContainer onClick={onClick}>
        <CashbackIcon color="var(--success-9)" size={size} />
      </PairElementContainer>
    </Tooltip>
  )
}
